import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const ProductSkeletonCardWrapper = Box.withConfig({
  width: 'full',
  backgroundColor: { base: primitive.$blackOpacity4, md: 'transparent' },
});

export const ProductSkeletonCardContainer = Box.withConfig({
  width: 'full',
  paddingTop: '$4',
});

export const ProductSkeletonCards = Box.withConfig({
  width: 'full',
  flexDirection: 'row',
  marginY: '$2',
  justifyContent: 'space-evenly',
});

export const SkeletonCard = Box.withConfig({
  width: '1/3',
  height: 160,
  padding: '$2',
});

export const SkeletonCardContent = Box.withConfig({
  flex: 1,
  background: primitive.$white,
  borderWidth: 2,
  borderColor: primitive.$blackOpacity10,
  borderRadius: primitive.$borderRadius,
  padding: '$2',
});
